export const DEFAULT_PRELOAD_COUNT = 8;

// Block problematic extensions on server rendering; FF is stringly-typed, macro names
// in the FF are comma-separated, such as "jira,include,decisionReport"
export const FF_SSR_EXTENSIONS_BLOCKLIST =
	'confluence.frontend.extensions.server-render-top-x.blocklist';
